package uz.ferro.erp.feature.excel

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.utils.repeatBlock
import uz.ferro.erp.feature.utils.replaceProp

object ExcelExportUtils {

    var template: String = ""

    private suspend fun loadTemplate() {
        if (template.isBlank()) {
            template = suspendGet(path = "/data/excel_template.xml", modifyPathDisabled = true)
        }
    }

    suspend fun exportToExcel(
        sheetName: String,
        head: List<String>,
        content: List<List<String>>
    ): String {
        loadTemplate()
        return template
            .replaceProp("sheet.name", sheetName)
            .repeatBlock(key = "header.cells", items = head) { txt, cell ->
                txt.replaceProp("cellContent", cell)
            }
            .repeatBlock(key = "content.rows", items = content) { contentBlock, row ->
                contentBlock.repeatBlock(key = "row.cells", items = row) { cellBlock, cell ->
                    cellBlock.replaceProp("cellContent", cell)
                }
            }
    }
}